const util = {
           
  s: function( num ){
    return num == 1 ? '' : 's';
  },
  
  ready: function( fn ){
    if( document.readyState != 'loading' ){
      fn();
    }else{
      document.addEventListener( 'DOMContentLoaded', fn );
    }
  },
           
  redirect: function( url ){
    window.location.href = url;
  },
  
  pad: function( num, width, x, dir ){
    var str = ''+num;
    while( str.length < width ){
      if( dir === 'left' ){
        str = x + str;
      }else{
        str = str + x;
      }
    }
    return str;
  },
  
  targetClicked: function( target, els ){
    
    if( !Array.isArray( els ) ){
      els = [els];
    }
    
    while( target ){
      
      var doBreak = false;
      
      for( var i=0; i<els.length; i++ ){
        if( target == els[i] ){
          doBreak = true;
          break;
        }
      };
      
      if( doBreak ){
        break;
      }
      
      target = target.parentNode;
      
    }
    
    return !!target;
    
  },
  
   /*
   *  t = current time
   *  b = begin
   *  c = change
   *  d = duration
  */
  easeInOutQuad: function( t, b, c, d ){
    if( ( t /= d / 2 ) < 1 ){
      return c / 2 * t * t + b;
    }
    return -c / 2 * ( (--t) * ( t - 2 ) - 1 ) + b;
  },
  
  animate: function( el, initial, target, transform, duration, cb ){
    
    var current = initial;
    
    var currentTime = 0;
    
    var smoothness = 10;
    
    var animation = setInterval( () => {
      
      currentTime += smoothness;
      
      current = util.easeInOutQuad( currentTime, initial, target - initial, duration );
      
      transform( current );
      
      if( current == target ){
        
        clearInterval( animation );
        
        if( cb ){
          cb();
        }
        
      }
      
    }, smoothness );
    
  },
  
  minutes2hours: function( minutes ){
    return this.pad( Math.floor( minutes / 60 ), 1, '0', 'left' ) + ':' + this.pad( Math.floor( minutes % 60 ), 2, '0', 'left' );
  },
    
  fromDateString: function( dateString ){
    return new Date( dateString + ' ' + ( new Date() ).toString().match(/GMT[\+\-][0-9]{4}/)[0] );
  },
    
  toDateString: function( date ){
    if( !( date instanceof Date ) ){
      return null;
    }
    return date.getFullYear() + '-' + util.pad( date.getMonth() + 1, 2, '0', 'left' ) + '-' + util.pad( date.getDate(), 2, '0', 'left' );
  },
    
  toFriendlyDateString: function( date ){
    if( !( date instanceof Date ) ){
      return null;
    }
    return date.getDate() + ' ' + util.monthNamesShort[ date.getMonth() ] + ' ' + date.getFullYear();
  },
  
  toTimeString: function( _date ){
    var date = _date;
    if( date === null ){
      return null;
    }
    if( !( date instanceof Date ) ){
      if( date.match( /^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}(\.[0-9]+Z)$/ ) ){
        date = new Date( date );
      }
      if( !date ){
        return null;
      }
    }
    return util.pad( date.getHours(), 2, '0', 'left' ) + ':' + util.pad( date.getMinutes(), 2, '0', 'left' );
  },
  
  toDateTimeString: function( date ){
    if( !( date instanceof Date ) ){
      return null;
    }
    return util.toDateString( date ) + ' ' + util.toTimeString( date );
  },
  
  toRelativeDate: function( date, target ){
    
    if( !( date instanceof Date ) ){
      return null;
    }
    if( !target ){
      target = new Date();
    }else if( !( target instanceof Date ) ){
      return null;
    }
    
    var diff = Math.abs( ( target.getTime() - date.getTime() ) / 1000 );
    
    var diffString = '';
    
    if( diff < 60 ){
      diffString = Math.floor( diff ) + ' second' + this.s( diff );
    }else if( diff < 60*60 ){
      diff = Math.floor( diff / 60 );
      diffString = diff + ' minute' + this.s( diff );
    }else if( diff < 60*60*24 ){
      diff = Math.floor( diff / (60*60) );
      diffString = diff + ' hour' + this.s( diff );
    }else if( diff < 60*60*24*7 ){
      diff = Math.floor( diff / (60*60*24) );
      diffString = diff + ' day' + this.s( diff );
    }else if( diff < 60*60*24*(365/12) ){
      diff = Math.floor( diff / (60*60*24*7) );
      diffString = diff + ' week' + this.s( diff );
    }else if( diff < 60*60*24*365 ){
      diff = Math.floor( diff / (60*60*24*(365/12) ) );
      diffString = diff + ' month' + this.s( diff );
    }else{
      diff = Math.floor( diff / (60*60*24*365) );
      diffString = diff + '+ year' + this.s( diff );
    }
    
    if( target < date ){
      return 'In ' + diffString;
    }else{
      return diffString + ' ago';
    }
    
  },
  
  toTimezone: function( date, tz ){
    return new Date( ( date instanceof Date ? date : new Date( date ) ).toLocaleString( 'en-US', { timeZone: tz } ) );
  },
  
  roundUpToNearest: function( num, nearest ){
    return Math.ceil( num / nearest ) * nearest;
  },
  
  roundToNearest: function( num, nearest ){
    return Math.floor( num / nearest ) * nearest;
  },
  
  displayDuration: function( startDate, addTime, _time ){
    
    if( !( startDate instanceof Date ) ){
      return null;
    }
    
    var pad = function( num ){
      return num >= 10 ? num : ( '0' + num )
    };
    
    var time = typeof( _time ) != 'undefined' ? _time : new Date();
    var diff = time.getTime() - startDate.getTime();
    diff = Math.max( diff, 0 );
    
    if( addTime ){
      diff += addTime;
    }
    
    var seconds = Math.floor( diff / 1000 );
    var minutes = Math.floor( seconds / 60 );
    var hours = Math.floor( minutes / 60 );
    var days = Math.floor( hours / 24 );
    
    hours = hours % 24;
    minutes = minutes % 60;
    seconds = seconds % 60;
    
    if( isNaN( hours ) || isNaN( minutes ) || isNaN( seconds ) ){
      return '...';
    }
                  
    return ( days > 0 ? ( days + '.' ) : '' ) + ( hours + ':' ) + ( pad( minutes ) + ':' ) + pad( seconds );
    
  },
  
  formatTimezone: function( tz, forAutocomplete ){ 
    if( !tz ){
      return null;
    }
    var parts = tz.split('/');
    if( parts.length == 2 ){
      if( forAutocomplete ){
        return parts[1].replace( '_', ' ' ) + ' - ' + parts[0].replace( '_', ' ' );        
      }else{
        return parts[1].replace( '_', ' ' ) + ' (' + parts[0].replace( '_', ' ' ) + ')';
      }
    }else{
      return tz.replace( '_', ' ' );
    }
  },
  
  updateFavicon: function( url ){
    
    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = url;
    document.getElementsByTagName('head')[0].appendChild(link);
    
  },
  
  getQueryParam: function( param ){
    var search = document.location.search;
    if( search.length > 1 ){
      var queryParams = search.substr(1).split('&');
      for( var q in queryParams ){
        var parts = queryParams[q].split('=');
        if( parts[0] == param ){
          return parts[1];
        }
      }
    }
    return null;
  },
  
  dayNames: [ 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday' ],
  dayNamesShort: [ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat' ],
  
  dayName: function( date ){
    return util.dayNames[ date.getDay() ];
  },
 
  monthNames: [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ],  
  monthNamesShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ],
      
  truncate: function( str, n ){
    return str ? ( str.length > n ? ( str.substr( 0, 15 ) + '...' ) : str ) : '';
  },
  
  showIfLongerThan: function( str, len ){
    return ( str && str.length > len ) ? str : '';
  },
  
  urlParamsFromString: function( paramString ){
      
    var params = {};
      
    paramString.split('&').forEach(function( param ){
      
      if( param.length > 0 ){
      
        var parts = param.split('=');
        params[ parts[0] ] = decodeURIComponent( parts[1].replace( /\+/g, ' ' ) );
        
      }
      
    });
    
    return params;
    
  },
  
  convertBase64ToBinary: function( base64 ){
    
    var raw = window.atob( base64 );
    var rawLength = raw.length;
    
    var array = new Uint8Array( new ArrayBuffer( rawLength ) );

    for( var i=0; i < rawLength; i++ ){
      array[i] = raw.charCodeAt(i);
    }
    
    return array;
    
  }
  
};
  
export default util;